export default "__VITE_ASSET__1bd94234__"